import { render, staticRenderFns } from "./carbrands.vue?vue&type=template&id=7dcf24aa&scoped=true"
import script from "./carbrands.vue?vue&type=script&lang=js"
export * from "./carbrands.vue?vue&type=script&lang=js"
import style0 from "./carbrands.vue?vue&type=style&index=0&id=7dcf24aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcf24aa",
  null
  
)

export default component.exports